import React from 'react'
import Grid from '@mui/material/Grid'
import { IoMdCheckboxOutline } from 'react-icons/io'
import './BuildingAndProperty.scss'

const HazardousMaterials = React.memo(({ hazardousMaterialsEntity }) => {
  const hazardousMaterials = React.useMemo(() =>hazardousMaterialsEntity, [hazardousMaterialsEntity])

  return (
    <>
      {hazardousMaterials &&
        hazardousMaterials !== null && ((hazardousMaterials.ammunition && hazardousMaterials.ammunition.isChecked)
        || (hazardousMaterials.oxygenTanks && hazardousMaterials.oxygenTanks.isChecked) || 
        (hazardousMaterials.gasolineTanks && hazardousMaterials.gasolineTanks.isChecked) ||
        (hazardousMaterials.propaneTanks && hazardousMaterials.propaneTanks.isChecked) || 
        (hazardousMaterials.chlorineContainers && hazardousMaterials.chlorineContainers.isChecked) ||
        (hazardousMaterials.otherMaterial && hazardousMaterials.otherMaterial.isChecked))? (
        <h2 className="section-title">Hazardous Materials</h2>
      ) 
      : null}
      {hazardousMaterials &&
        hazardousMaterials !== null && ((hazardousMaterials.ammunition && hazardousMaterials.ammunition.isChecked)
        || (hazardousMaterials.oxygenTanks && hazardousMaterials.oxygenTanks.isChecked) || 
        (hazardousMaterials.gasolineTanks && hazardousMaterials.gasolineTanks.isChecked) ||
        (hazardousMaterials.propaneTanks && hazardousMaterials.propaneTanks.isChecked) || 
        (hazardousMaterials.chlorineContainers && hazardousMaterials.chlorineContainers.isChecked) ||
        (hazardousMaterials.otherMaterial && hazardousMaterials.otherMaterial.isChecked)) ? (
        <Grid className="section">
          <Grid className="container-field">
            {hazardousMaterials &&
              hazardousMaterials.oxygenTanks && 
              hazardousMaterials.oxygenTanks.isChecked !== null &&
              hazardousMaterials.oxygenTanks.isChecked ? (
              <Grid>
                <label>
                {hazardousMaterials.oxygenTanks.isChecked ? (
                    <>
                      {<IoMdCheckboxOutline />} Oxygen tanks
                      {hazardousMaterials.oxygenTanks.isChecked && 
                        hazardousMaterials.oxygenTanks.location &&
                        hazardousMaterials.oxygenTanks.location !== null ? (
                          <>
                            {`, ${hazardousMaterials.oxygenTanks.location}`}
                          </>
                        ) : null}
                    </>
                  ) : ""}
                </label>
              </Grid>
            ) : null}

            {hazardousMaterials &&
              hazardousMaterials.gasolineTanks && 
              hazardousMaterials.gasolineTanks.isChecked !== null &&
              hazardousMaterials.gasolineTanks.isChecked ? (
              <Grid>
                <label>
                  {hazardousMaterials.gasolineTanks.isChecked ? (
                    <>
                      {<IoMdCheckboxOutline />} Gasoline tanks
                      {hazardousMaterials.gasolineTanks.isChecked && 
                        hazardousMaterials.gasolineTanks.location &&
                        hazardousMaterials.gasolineTanks.location !== null ? (
                          <>
                            {`, ${hazardousMaterials.gasolineTanks.location}`}
                          </>
                        ) : null}
                    </>
                  ) : ""}
                </label>
              </Grid>
            ) : null}

            {hazardousMaterials &&
              hazardousMaterials.propaneTanks && 
              hazardousMaterials.propaneTanks.isChecked !== null &&
              hazardousMaterials.propaneTanks.isChecked ? (
              <Grid>
                <label>
                  {hazardousMaterials.propaneTanks.isChecked ? (
                    <>
                      {<IoMdCheckboxOutline />} Propane tanks
                      {hazardousMaterials.propaneTanks.isChecked && 
                      hazardousMaterials.propaneTanks.location &&
                      hazardousMaterials.propaneTanks.location !== null ? (
                        <>
                          {`, ${hazardousMaterials.propaneTanks.location}`}
                        </>
                      ) : null}
                    </>
                  ) : ""}
                </label>
              </Grid>
            ) : null}

            {hazardousMaterials &&
              hazardousMaterials.ammunition && 
              hazardousMaterials.ammunition.isChecked !== null &&
              hazardousMaterials.ammunition.isChecked ? (
              <Grid>
                <label>
                  {hazardousMaterials.ammunition.isChecked ? (
                    <>
                      {<IoMdCheckboxOutline />} Ammunition
                      {hazardousMaterials.ammunition.isChecked && 
                      hazardousMaterials.ammunition.location &&
                      hazardousMaterials.ammunition.location !== null ? (
                          <>
                            {`, ${hazardousMaterials.ammunition.location}`}
                          </>
                      ) : null}
                    </>
                  ) : ""}
                </label>
              </Grid>
            ) : null}

            {hazardousMaterials &&
              hazardousMaterials.chlorineContainers && 
              hazardousMaterials.chlorineContainers.isChecked !== null &&
              hazardousMaterials.chlorineContainers.isChecked ? (
              <Grid>
                <label>
                  {hazardousMaterials.chlorineContainers.isChecked ? (
                    <>
                      {<IoMdCheckboxOutline />} Chlorine containers
                      {hazardousMaterials.chlorineContainers.isChecked && 
                        hazardousMaterials.chlorineContainers.location &&
                        hazardousMaterials.chlorineContainers.location !== null ? (
                          <>
                            {`, ${hazardousMaterials.chlorineContainers.location}`}
                          </>
                        ) : null}
                    </>
                  ) : ""}
                </label>
              </Grid>
            ) : null}

            {hazardousMaterials &&
              hazardousMaterials.otherMaterial && 
              hazardousMaterials.otherMaterial.isChecked !== null &&
              hazardousMaterials.otherMaterial.isChecked ? (
              <Grid>
                <label>
                  {hazardousMaterials.otherMaterial.isChecked ? <> 
                    
                  <label>
                    {hazardousMaterials.otherMaterial.isChecked ? (
                      <>
                        {<IoMdCheckboxOutline />} Any other hazardous materials {hazardousMaterials.otherMaterial.isChecked && ((hazardousMaterials.otherMaterial.description &&
                  hazardousMaterials.otherMaterial.description !== null) || (hazardousMaterials.otherMaterial.location &&
                    hazardousMaterials.otherMaterial.location !== null)) ? ":" : ""}
                      </>
                    ) : ""}
                  </label>

                  {hazardousMaterials.otherMaterial.isChecked && 
                  hazardousMaterials.otherMaterial.description &&
                  hazardousMaterials.otherMaterial.description !== null ? (
                    <>
                      <>
                        {hazardousMaterials.otherMaterial.description ? ` ${hazardousMaterials.otherMaterial.description}` : ""}
                      </>
                      {hazardousMaterials.otherMaterial.isChecked && 
                        hazardousMaterials.otherMaterial.location &&
                        hazardousMaterials.otherMaterial.location !== null ? (
                          <>{hazardousMaterials.otherMaterial.location ? `, ${hazardousMaterials.otherMaterial.location}` : ""}</>
                        ) : null}
                    </>
                  ) : null}

                  </> : ""}
                </label>
              </Grid>
            ) : null}
          </Grid>

        </Grid>
      ) : null}  
    </>
  )
})

export default HazardousMaterials